import {reducer} from '../helpers'

import {
  CALCULATE_RTK_ORDER_TOTALS,
  CALCULATE_RTK_ORDER_TOTALS_FAILURE,
  CALCULATE_RTK_ORDER_TOTALS_PENDING,
  CALCULATE_RTK_ORDER_TOTALS_SUCCESS,
  GET_ELIGIBLE_RTK_ITEMS,
  GET_ELIGIBLE_RTK_ITEMS_FAILURE,
  GET_ELIGIBLE_RTK_ITEMS_PENDING,
  GET_ELIGIBLE_RTK_ITEMS_SUCCESS,
  SAVE_RTK_BILLING_INFORMATION_FAILURE,
  SAVE_RTK_BILLING_INFORMATION_PENDING,
  SUBMIT_BILLING_STEP,
  SUBMIT_CHARGE_CARD_ON_FILE,
  SUBMIT_RTK_PURCHASE_FAILURE,
  SUBMIT_RTK_PURCHASE_PENDING,
  SUBMIT_RTK_PURCHASE_SUCCESS,
  SUBMIT_SELECT_ITEMS,
} from '../../actions/rentToKeep'
import {
  FETCH_PAYPAGE_REGISTRATION_ID_FAILURE,
  FETCH_PAYPAGE_REGISTRATION_ID_SUCCESS,
} from '../../actions/worldpay'
import {transformRTKEligibleOrders} from './helpers'
import {RTKSteps} from '../../store/rentToKeep/enums'

const initialState = {
  currentStep: RTKSteps.itemSelect,
  discountAmount: 0,
  errors: [],
  eventId: null,
  hasCalculateTotalsFailed: false,
  hasFetchingEligibleRTKItemsFailed: false,
  hasSavingBillingAddressFailed: false,
  hasSubmitPurchaseFailed: false,
  isFetchingCalculatedTotals: false,
  isFetchingEligibleRTKItems: false,
  isRentToKeepOfferActive: true,
  isSubmittingBillingInformation: false,
  isSubmittingPurchase: false,
  itemsToPurchase: [],
  orders: [],
  subtotal: null,
  tax: null,
  total: null,
}

export default reducer(initialState, (state, action) => {
  const {type} = action
  switch (type) {
    case SUBMIT_SELECT_ITEMS:
      return {
        currentStep: RTKSteps.billing,
        eventId: action.payload.eventId,
        itemsToPurchase: action.payload.itemsToPurchase,
      }
    case SUBMIT_BILLING_STEP:
      return {
        hasSavingBillingAddressFailed: false,
        isSubmittingBillingInformation: false,
      }
    case SUBMIT_CHARGE_CARD_ON_FILE:
      return {
        currentStep: RTKSteps.review,
      }
    case GET_ELIGIBLE_RTK_ITEMS:
      return {
        hasFetchingEligibleRTKItemsFailed: false,
        isFetchingEligibleRTKItems: false,
        isRentToKeepOfferActive: true,
        orders: [],
      }
    case GET_ELIGIBLE_RTK_ITEMS_PENDING: {
      return {
        isFetchingEligibleRTKItems: true,
      }
    }
    case GET_ELIGIBLE_RTK_ITEMS_SUCCESS: {
      return {
        isFetchingEligibleRTKItems: false,
        isRentToKeepOfferActive: action.payload.isRentToKeepOfferActive,
        orders: transformRTKEligibleOrders(action.payload.orders),
      }
    }
    case GET_ELIGIBLE_RTK_ITEMS_FAILURE: {
      return {
        hasFetchingEligibleRTKItemsFailed: true,
        isFetchingEligibleRTKItems: false,
      }
    }
    case SAVE_RTK_BILLING_INFORMATION_PENDING:
      return {
        isSubmittingBillingInformation: true,
      }
    case SAVE_RTK_BILLING_INFORMATION_FAILURE:
      return {
        hasSavingBillingAddressFailed: true,
        isSubmittingBillingInformation: false,
      }
    case FETCH_PAYPAGE_REGISTRATION_ID_SUCCESS:
      return {
        currentStep: RTKSteps.review,
        isSubmittingBillingInformation: false,
      }
    case FETCH_PAYPAGE_REGISTRATION_ID_FAILURE:
      return {
        isSubmittingBillingInformation: false,
      }
    case CALCULATE_RTK_ORDER_TOTALS: {
      return {
        discountAmount: 0,
        isFetchingCalculatedTotals: false,
        hasCalculateTotalsFailed: false,
        subtotal: 0,
        tax: 0,
        total: 0,
      }
    }
    case CALCULATE_RTK_ORDER_TOTALS_PENDING: {
      return {
        isFetchingCalculatedTotals: true,
        hasCalculateTotalsFailed: false,
      }
    }
    case CALCULATE_RTK_ORDER_TOTALS_FAILURE: {
      return {
        isFetchingCalculatedTotals: false,
        hasCalculateTotalsFailed: true,
      }
    }
    case CALCULATE_RTK_ORDER_TOTALS_SUCCESS: {
      return {
        discountAmount: action.payload.discountAmount,
        hasCalculateTotalsFailed: false,
        isFetchingCalculatedTotals: false,
        subtotal: action.payload.subtotal,
        tax: action.payload.tax,
        total: action.payload.total,
      }
    }
    case SUBMIT_RTK_PURCHASE_SUCCESS:
      return {
        errors: [],
        currentStep: RTKSteps.confirmation,
        isSubmittingPurchase: false,
        hasSubmitPurchaseFailed: false,
      }
    case SUBMIT_RTK_PURCHASE_FAILURE:
      return {
        errors: action.payload ? [action.payload] : [],
        isSubmittingPurchase: false,
        hasSubmitPurchaseFailed: true,
      }
    case SUBMIT_RTK_PURCHASE_PENDING:
      return {
        errors: [],
        isSubmittingPurchase: true,
        hasSubmitPurchaseFailed: false,
      }
    default:
      return null
  }
})
